<template>
    <AppHeader fixed>
      <template v-if="showAsideLeft">
        <!-- <SidebarToggler class="d-lg-none" display="md" mobile /> -->
        <SidebarToggler class="d-md-down-none" display="lg" />
      </template>

      <b-link class="navbar-brand" to="/help/kr/TIS50/43" style="width:225px;">
        <div class="logo">
        </div>
        <h5 class="p-1 px-2 pt-2 mt-1 text-dark"  style="font-weight:bold;"> 온라인 도움말</h5>
      </b-link>

      <b-navbar-nav class="ml-auto">

         <!-- <b-nav-item class="px-3" to="/help_management"><i class="icon-docs"></i> 문서 관리</b-nav-item> -->

        <!-- <b-nav-item class="d-md-down-none" to="">
          <HeaderDropdownCoreUI/>
        </b-nav-item> -->

        <!-- <b-nav-item class="" v-if="logined">
          <DefaultHeaderDropdownAccnt
            :token.sync="loginToken"
            @logout="doLogout"
          />
        </b-nav-item>
        <b-nav-item class="px-3" to="/login"  v-if="!logined"><i class="icon-user"></i> Login</b-nav-item> -->

      </b-navbar-nav>
    </AppHeader>
</template>

<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import HeaderDropdownCoreUI from './HeaderDropdownCoreUI'
import DevAuthorize from '@/shared/dev-authorize'
import { toggleBodyClass } from '@/shared/utils'

let orgidx = null;

export default {
  name: 'MainHeader',
  components: {
    AsideToggler,
    AppHeader,
    HeaderDropdownCoreUI,
    SidebarToggler,
  },
  data () {
    return {
      dropdownCount1: 0,
      logined: this.isLogined(),
      isDevelopMode: !(process.env.NODE_ENV === 'production'),

      basePath : "/devapi/v1/organizations",
      applicationBasePath : "/devapi/v1/applications",
      organizationIndex : -1,
      myOrganizations: [],
      myApplications: [],
      applications: [],


    }
  },
  props: {
    showAsideLeft: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showOrganizations: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    if(!(process.env.NODE_ENV === 'production')) console.log("beforeRouteEnter...", to, from);

    orgidx = to.params.orgidx;
    console.log("orgidx", orgidx);

    next();
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()

    // console.log("beforeRouteUpdate...", to);
    if(from.params.orgidx != to.params.orgidx || !this.myOrganizations || this.myOrganizations.length === 0) {
      orgidx = to.params.orgidx;
      this.initOrganizations();
      this.initApplications();
    }

    next();
  },
  beforeCreate: function () {
    // if (!this.$session.exists() || !DevAuthorize.isLogined(this)) {
    //   this.$router.push('/login')
    // }
  },
  created: function() {
    let _this = this;
    if(this.isLogined()) {
      this.loginToken = DevAuthorize.loadToken(this);
      DevAuthorize.validate(this, function(validatation) {
        if(validatation === false) {
          _this.logined = false;
          _this.$session.destroy();

          DevAuthorize.logout(_this, function(res) {
            _this.loginToken = null;
          });
        }
      });
      // console.log(this.loginToken);
    }
  },
  mounted: function() {
    if(this.showAsideLeft) {
      toggleBodyClass("addClass", "sidebar-fixed");
      toggleBodyClass("removeClass", "sidebar-hidden");
    } else {
      toggleBodyClass("addClass", "sidebar-hidden");
      toggleBodyClass("removeClass", "sidebar-fixed");
    }

    this.initOrganizations();
    this.initApplications();
  },
  methods: {
    initOrganizations() {
      const _vm = this;
      DevAuthorize.get(this, this.basePath + "/", {}, (res, data) => {
        const code = data.code;
        const message = data.response && data.response.data ? data.response.data.message : data.message; // error : normal
        if(res) {
          if(data.organizations) {
            _vm.myOrganizations = data.organizations;
            _vm.organizationIndex = orgidx ? orgidx : data.organizations[0].organizationIdx;
          }
        } else if(code === "2001") {
            _vm.hasOrganization = false;
        } else {
          console.log("서버에 접속할 수 없거나 소속된 조직이 없습니다.");
        }
      });
    },
    initApplications() {
      const _vm = this;
      DevAuthorize.get(this, this.applicationBasePath + "/",  {my: true, orgidx : 0}, (res, data) => {
        const code = data.code;
        const message = data.response && data.response.data ? data.response.data.message : data.message; // error : normal
        if(res) {
          if(data.applications) {
            _vm.myApplications = data.applications;
          }
        } else if(code === "2001") {
            console.log("내 애플리케이션이 없습니다.");
            _vm.myApplications = [];
        } else {
          console.log("서버에 접속할 수 없거나 소속된 애플리케이션이 없습니다.");
        }
      });
      DevAuthorize.get(this, this.applicationBasePath + "/",  {my: false, orgidx : 0}, (res, data) => {
        const code = data.code;
        const message = data.response && data.response.data ? data.response.data.message : data.message; // error : normal
        if(res) {
          if(data.applications) {
            _vm.applications = data.applications;
          }
        } else if(code === "2001") {
            // console.log("소속된 애플리케이션이 없습니다.");
            _vm.applications = [];
        } else {
          console.log("서버에 접속할 수 없거나 소속된 애플리케이션이 없습니다.");
        }
      });
    },
    doLogout: function () {
      DevAuthorize.logout(this, (res) => {
        if(res) {
          // console.log("do logout............");
          this.$session.destroy()
          this.$router.push('/')
        } else {
          this.$session.destroy()
          this.$router.push('/')
        }
      });
    },
    isLogined: function() {
      return DevAuthorize.isLogined(this) && this.$session.exists();
    },



    onChangeOrganization() {
      this.myOrganizations.forEach(organization => {
        if(organization.organizationIdx === this.organizationIndex) {
          if(organization.developerTypeinfo == "30") {
            this.$router.push("/developers/orgs/" + this.organizationIndex + "/apps")
          } else {
            this.$router.push("/developers/statistics/" + this.organizationIndex + "/quota")
          }
        }
      });
    },


    onUpdateDown1(value) {
      this.dropdownCount1 = value;
    },

  }
}
</script>


<style lang="css" scoped>
.main > div.container-fluid {
  padding: 0 1rem;
}
.logo {
  width: 95px;
    height: 21px;
    float: left;
    background: url(/images/tachyon/logo_v10.png);
    cursor: pointer;
    background-repeat: no-repeat;
}
.navbar-toggler {
  display: none;
}

</style>